import { render, staticRenderFns } from "./UsersWrapper.vue?vue&type=template&id=fc839820"
import script from "./UsersWrapper.vue?vue&type=script&lang=js"
export * from "./UsersWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports